module.exports = __webpack_public_path__ + "img/zubair.a898da18.jpg";